export default {
  SMALL: 480,
  MEDIUM: 767,
  LARGE: 980,
  X_LARGE: 1280,
  XX_LARGE: 1350,
};
